module.exports = __webpack_public_path__ + "static/media/hamburger-gray.78b2a8eb.svg";